"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * MyBuy Backend API
 * ## Release Notes  ### v0.0.1  Work in progress
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.NavigationEntry2AllOfToJSON = exports.NavigationEntry2AllOfFromJSONTyped = exports.NavigationEntry2AllOfFromJSON = void 0;
var runtime_1 = require("../runtime");
var _1 = require("./");
function NavigationEntry2AllOfFromJSON(json) {
    return NavigationEntry2AllOfFromJSONTyped(json, false);
}
exports.NavigationEntry2AllOfFromJSON = NavigationEntry2AllOfFromJSON;
function NavigationEntry2AllOfFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'subEntries': !(0, runtime_1.exists)(json, 'subEntries') ? undefined : (json['subEntries'].map(_1.NavigationEntry3FromJSON)),
    };
}
exports.NavigationEntry2AllOfFromJSONTyped = NavigationEntry2AllOfFromJSONTyped;
function NavigationEntry2AllOfToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'subEntries': value.subEntries === undefined ? undefined : (value.subEntries.map(_1.NavigationEntry3ToJSON)),
    };
}
exports.NavigationEntry2AllOfToJSON = NavigationEntry2AllOfToJSON;
//# sourceMappingURL=NavigationEntry2AllOf.js.map